module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_okunai@3x-4fdf51895ab57b3e9c4858830445865a.webp";